/**
 * Used for Pet Name validaion
 * allows digits, letters, spaces and some special characters
 * (period, underscore, hyphen, & apostrophe)
 */
export const petNameRegEx: RegExp = /^([a-z\d][\_\-\'\. a-z\d]*)$/im;

/**
 * Used for First & last name validation
 * Allows letters, spaces, apostrophe, and hyphens
 */
export const petParentRegEx: RegExp = /^([a-z][\-\' a-z]+)$/im;

export const dateOfBirthRegEx: RegExp = /^(0[1-9]|1[012])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d\d$/i;
